/* eslint-disable formatjs/no-literal-string-in-jsx */
import { rem } from 'polished'
import { useEffect, useState } from 'react'
import styled from 'styled-components'

const DEBUG_EVENT = 'debug-loyalty-package-upgrades-change'
let debugEnabled = false

const LoyaltyPackageUpgradeDebugBadge = styled.pre`
  margin: 0 0 ${rem(8)};
  padding: ${rem(8)};
  border: 2px solid #ff00aa;
  border-radius: ${rem(4)};
  background: #fff200;
  color: #1f005c;
  font-size: ${rem(12)};
  font-weight: 700;
  line-height: 1.4;
  white-space: pre-wrap;
  word-break: break-all;
`

declare global {
  interface Window {
    __DEBUG_LOYALTY_PACKAGE_UPGRADES__?: (enabled?: boolean) => boolean
  }
}

function getDebugEnabled() {
  return debugEnabled
}

type Props = {
  rate: App.EnrichedPropertyRate
  packageUpgradeTargetRate?: App.EnrichedPropertyRate
}

/**
 * Temporary debug UI for validating property package-upgrade source/target rates.
 * Enable in the browser console with `window.__DEBUG_LOYALTY_PACKAGE_UPGRADES__(true)`.
 */
function PropertyLoyaltyPackageUpgradeDebug(props: Props) {
  const { rate, packageUpgradeTargetRate } = props
  const [enabled, setEnabled] = useState(getDebugEnabled)

  useEffect(() => {
    window.__DEBUG_LOYALTY_PACKAGE_UPGRADES__ = (nextEnabled = !getDebugEnabled()) => {
      debugEnabled = nextEnabled
      window.dispatchEvent(new CustomEvent(DEBUG_EVENT))
      return nextEnabled
    }

    const onDebugChange = () => setEnabled(getDebugEnabled())
    window.addEventListener(DEBUG_EVENT, onDebugChange)

    // Only the listener is removed. One badge renders per rate tile, so they share the console
    // hook — deleting it when a single tile unmounts would take the toggle away from every tile
    // still on screen. Re-registering on each mount makes leaving it in place harmless.
    return () => {
      window.removeEventListener(DEBUG_EVENT, onDebugChange)
    }
  }, [])

  if (!enabled) {
    return null
  }

  return <LoyaltyPackageUpgradeDebugBadge>
    {`rateId: ${rate.rateId}\nrateType: ${rate.service.type}\npackageUpgradeRateId: ${packageUpgradeTargetRate?.rateId ?? 'none'}\npackageUpgradeRateType: ${packageUpgradeTargetRate?.service.type ?? 'none'}`}
  </LoyaltyPackageUpgradeDebugBadge>
}

export default PropertyLoyaltyPackageUpgradeDebug
